module.exports = __webpack_public_path__ + "static/media/cccd_after.38bf8f7c.png";